import Repository from "@/plugins/axios";

export default {
  // Получить страницу "О биеннале"
  getAbout() {
    return Repository.get(`/biennale/about`);
  },
};
